// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__+G8jV","terms__checkbox":"Terms_terms__checkbox__u8ATQ","terms__icon":"Terms_terms__icon__wJ64g","terms__error":"Terms_terms__error__99RJk"};